export default "__VITE_ASSET__BgDQbXqE__"